import React, { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2, Factory } from 'lucide-react';

const AuthCallback = () => {
  const { processGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          alert('No se encontró la sesión');
          window.location.href = '/login';
          return;
        }

        // Process the session
        const user = await processGoogleSession(sessionId);
        
        // Redirect based on whether user has a company
        // Use window.location for more reliable mobile navigation
        if (user && user.company_id) {
          window.location.href = '/dashboard';
        } else {
          window.location.href = '/dashboard/company/new';
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        alert('Error al procesar la autenticación');
        window.location.href = '/login';
      }
    };

    processAuth();
  }, [processGoogleSession]);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center">
      <div className="flex items-center gap-2 mb-8">
        <Factory className="w-10 h-10 text-slate-900" />
        <span className="font-manrope text-2xl font-bold text-slate-900">TexHub</span>
      </div>
      <div className="flex items-center gap-3">
        <Loader2 className="w-6 h-6 animate-spin text-emerald-600" />
        <span className="text-slate-600 font-inter">Procesando autenticación...</span>
      </div>
    </div>
  );
};

export default AuthCallback;
